import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

function Detail() {
  return (
     <>
            <Header />

            <main>
                {/*===== HERO AREA START =====*/}
                <div
                    className="inner-hero"
                    style={{ backgroundImage: "url(assets/img/bg/Ashok.jpg)" }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 m-auto text-center">
                                <div className="inner-main-heading">
                                    <h1>Blog Detail</h1>
                                    <div className="breadcrumbs-pages">
                                        {/* <ul>
                <li>
                  <a href="index.html">Home</a>
                </li>
                <li className="angle">
                  <i className="fa-solid fa-angle-right" />
                </li>
                <li>Daily Blog</li>
              </ul> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*===== HERO AREA START =====*/}
                {/*===== BLOG DETAILS AREA START =====*/}
                <div className="blog-details-area sp">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 m-auto">
                                <div className="blog-details-content">
                                    <article>
                                        <div className="details-content">
                                            <div className="image">
                                                <img
                                                    className="w-full"
                                                    src="assets/img/blog/b4.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            {/* <div className="vl-blog12-meta mt-24">
                                                <a href="#" className="date">
                                                    <img src="assets/img/icons/date1.svg" alt="" /> 12/12/2025
                                                </a>
                                                <a href="#" className="author">
                                                    <img src="assets/img/icons/author1.svg" alt="" /> John Doe
                                                </a>
                                            </div> */}
                                            <div className="heading2 mt-24">
                                                <h3>
New World Order: Iran Emerges as a New Global Power — In a stunning series of events during the recent 12-day war in West Asia

                                                </h3>
                                                <p className=" mt-16">
The conflict, initially expected to remain localized, escalated rapidly. Israel’s aggressive stance met with an unprecedented level of resistance from Iran. Despite the involvement of the United States, which made a show of military support for Israel, their intervention was widely viewed as symbolic. Reports confirmed that American bombs lacked the impact needed to break through Iran’s hardened bunkers, some buried over 90 feet deep and reinforced into mountain slopes.

                                                </p>
                                                <br></br>

                                                <p>

Iran’s counterstrike — a calibrated attack with 14 missiles on an American base — was equally symbolic, sending a clear message: Iran would respond, but on its own terms. What followed was even more unexpected — Israel, battered by the resistance, effectively surrendered, leading to a major shift in regional power equations.
Perhaps the most surprising outcome of the war was the unification of Sunni and Shia sentiments under the leadership of Iran’s Supreme Leader, Ayatollah Khomeini. Traditionally, the Sunni-Shia divide has been a major fault line within the Muslim world. However, Iran’s unwavering support for the Sunni-majority Palestinians and its decisive stance against Israel won it admiration across sectarian lines.

                                                </p>
                                                <br></br>

                                                <p>

From Cairo to Karachi and from Damascus to Dakar, Khomeini is now being projected as a unifying figure of the Islamic world. Iran, traditionally a Shia power, has managed to forge a pan-Islamic identity that resonates with nearly 2 billion Muslims, extending its influence into Africa and Southeast Asia. This newfound unity is challenging long-standing Western influence in the region and heralds the arrival of a multipolar world order.

                                                </p>
                                                <br></br>

                                                <p>

Before this shift, many analysts believed that the invincible Mossad would resume its power and again start controlling the middle east. The big diplomats, retired generals and analysts claimed that Mossad has very high technology. Some of these imaginations were like the expectations in Mongolia that someday Chengiz Khan will rise from his graves and bring back glory and power to Mongolia.
In fact, Mossad only used its old agents to kill senior most generals and nuclear scientists of Iran. These sleeping agents were placed immediately after the Iranian revolution. Old Iranian Jews were replaced by Mossad agents. Otherwise, Mossad had no big technology. Israel primarily used American and western technology and armaments. Mossad, once feared, now seems like a relic from another era.
                                                </p>
                                                <br></br>

                                                <p>

Russia and China, while not directly involved in the conflict, expressed readiness to support Iran if requested. This further boosted Tehran’s confidence, reinforcing its image as a power capable of standing alone.
Fallout for India
India’s unambiguous tilt towards Israel during the conflict has had serious diplomatic repercussions. With Iran emerging as the new leader of the Muslim world, India's position has weakened in the region. The once-promising Chabahar Port project — key to India’s West Asian ambitions — is now largely controlled by China, along with billions in lost investments.
Iran, now closer to Pakistan, is expected to support its neighbor in any future regional disputes. India’s access to cheap Iranian oil is also uncertain. Domestically, the government’s pro-Israel stance has drawn criticism from a significant section of the population, especially among Indian Muslims, who see Iran as a defender of Muslim dignity worldwide.
The New World Order
The events of the last few weeks are not just about territorial gains or military strategies. They signify the rise of a new world order — one not defined by the West but shaped by the East. Iran, through resilience and strategic depth, has positioned itself as the voice of the Global South and the Islamic world.
For India, this moment demands introspection. Alignments are shifting. Old friendships are being tested. And in this rapidly changing global landscape, neutrality may no longer be an option.
Ashok Nanda
                                                </p>
                                                <br></br>
                                                

                                                <br></br>



                                            </div>


                                        </div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*===== BLOG DETAILS AREA END =====*/}

            </main>


            <Footer />
        </>
  );
}

export default Detail;
